import { FC, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import AddWhatsNew from 'common/components/custom/add-whats-new/AddWhatsNew';
import { MAIN_ROUTES } from 'common/config/routes.config';
import { RootState } from 'common/redux/core/root.reducer';
import { getUserName } from 'common/redux/user/user.selector';

import Home from 'modules/home/pages/home/Home';
import DataEditor from 'modules/data-editor/pages/data-editor/DataEditor';
import MasterData from 'modules/master-data/pages/master-data/MasterData';
import Variants from 'modules/master-data/pages/variants/Variants';
import ArchiveList from 'modules/archive/pages/archive-list/ArchiveList';
import TrendingData from 'modules/configuration/pages/trending-data/TrendingData';
import WhatsNew from 'modules/configuration/pages/whats-new/WhatsNew';
import KeyIndicator from 'modules/configuration/pages/key-indicator/KeyIndicator';
import FrequentlyUsed from 'modules/configuration/pages/frequently-used/FrequentlyUsed';
import StaticIndicator from 'modules/configuration/pages/static-indicator/StaticIndicator';
import GeographyOverview from 'modules/configuration/pages/geography-overview/GeographyOverview';
import AddEditVideoLinks from 'common/components/custom/add-video-link/AddEditVideoLinks';
import VideoLinks from 'modules/configuration/pages/video-links/VideoLink';
import UploadListPage from 'modules/configuration/pages/upload-list-page/UploadListPage';
import IndicatorSources from 'modules/configuration/pages/indicator-sources/IndicatorSources';
import SyncHistory from 'modules/sync-history/pages/sync-history/SyncHistory';
import UserPermissions from 'modules/user-management/pages/user-permissions/UserPermissions';
import AdminRoleManagement from 'modules/admin-roles-management/pages/role-management/AdminRoleManagement';
import SideNav from './side-nav';
import { msalInstance, mandatoryLogoutTimer } from 'common/config';
import './AuthorizedLayout.scss';
import CompanyFootprint from 'modules/data-management/pages/company-footprint/CompanyFootprint';
import AuthorizedRoutes from './authorized-routes/Authorized-routes';

const AuthorizedLayout: FC = () => {
    const userName = useSelector((state: RootState) => getUserName(state));
    const location = useLocation();
    const isSideNavVisible = location.pathname !== MAIN_ROUTES.HOME ? true : false;

    /**
     * mandatorily logout the user after 10 hours
     */
    useEffect(() => {
        const logout = () => {
            msalInstance.logoutRedirect();
        };
        const logoutTimer = setTimeout(logout, mandatoryLogoutTimer);
        return () => clearTimeout(logoutTimer);
    }, []);

    return (
        <div className="auth-layout-container">
            <div className="auth-layout-main">
                {isSideNavVisible && (
                    <div className="auth-layout-sideNav">
                        <SideNav />
                    </div>
                )}
                <div className="auth-layout-content">
                    {/* <Routes>
                        <Route
                            path={MAIN_ROUTES.HOME}
                            element={<Home userName={userName} hasAccess={true} />}
                        />
                        <Route
                            path={MAIN_ROUTES.DEFAULT}
                            element={<Navigate to={MAIN_ROUTES.HOME} />}
                        />
                        <Route
                            path={MAIN_ROUTES.WILD}
                            element={<Navigate to={MAIN_ROUTES.HOME} />}
                        />
                        <Route path={MAIN_ROUTES.DATA_EDITOR} element={<DataEditor />} />
                        <Route path={MAIN_ROUTES.MASTER_DATA} element={<MasterData />} />
                        <Route path={MAIN_ROUTES.VARIANTS} element={<Variants />} />
                        <Route path={MAIN_ROUTES.WHATS_NEW_CREATE_NEW} element={<AddWhatsNew />} />
                        <Route
                            path={MAIN_ROUTES.VIDEO_LINKS_CREATE_NEW}
                            element={<AddEditVideoLinks />}
                        />
                        <Route path={MAIN_ROUTES.ARCHIVE} element={<ArchiveList />} />
                        <Route
                            path={MAIN_ROUTES.CONFIGURATION_TRENDING_DATA}
                            element={<TrendingData />}
                        />
                        <Route path={MAIN_ROUTES.CONFIGURATION_WHATS_NEW} element={<WhatsNew />} />
                        <Route
                            path={MAIN_ROUTES.CONFIGURATION_FREQ_USED}
                            element={<FrequentlyUsed />}
                        />
                        <Route
                            path={MAIN_ROUTES.CONFIGURATION_KEY_INDICATOR}
                            element={<KeyIndicator />}
                        />
                        <Route
                            path={MAIN_ROUTES.CONFIGURATION_STATIC_INDICATOR}
                            element={<StaticIndicator />}
                        />
                        <Route
                            path={MAIN_ROUTES.CONFIGURATION_GEOGRAPHY_OVERVIEW}
                            element={<GeographyOverview />}
                        />
                        <Route
                            path={MAIN_ROUTES.CONFIGURATION_VIDEO_LINKS}
                            element={<VideoLinks />}
                        />
                        <Route
                            path={MAIN_ROUTES.DATA_MANAGEMENT_INDICATOR_SOURCES}
                            element={<IndicatorSources />}
                        />
                        <Route
                            path={MAIN_ROUTES.DATA_MANAGEMENT_COMPANY_FOOTPRINT}
                            element={<CompanyFootprint />}
                        />
                        <Route
                            path={MAIN_ROUTES.ADMIN_ROLES_MANAGEMENT}
                            element={<AdminRoleManagement />}
                        />
                        <Route path={MAIN_ROUTES.UPLOAD_LIST_PAGE} element={<UploadListPage />} />
                        <Route path={MAIN_ROUTES.SYNC_LOGS} element={<SyncHistory />} />
                    </Routes> */}
                    {/* <Routes> */}
                    <AuthorizedRoutes />
                    {/* </Routes> */}
                </div>
            </div>
        </div>
    );
};

export default AuthorizedLayout;
